import React, { Component } from 'react';

import moment from 'moment';

import './JobApplication.scss';

class JobApplication extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const ParagonRefered = this.props['job-application-data'].history.some(x => x.users_to_job_openings_status_id === 10);
    const getDate = Time => {
      if (Time !== null) {
        return moment(Time).format('MMM DD, YYYY');
      }

      return 'unknown date';
    }

    return (
      <div className='job-application'>
        <p className='job-application__date'>Received on <span>{getDate(this.props['job-application-data'].date_applied)}</span></p>
        <p className='job-application__status'>Status: {this.props['job-application-data'].status.name}</p>
        {/* <p className='job-application__industry'>{this.props['job-application-data'].industry}</p> */}
        <p className='job-application__company'>{this.props['job-application-data'].job_opening.company_name}</p>
        <p className='job-application__position'>{this.props['job-application-data'].job_opening.title}</p>
        <p className='job-application__referrer'>{ParagonRefered ? 'Referred by Paragon One' : ''}</p>
      </div>
    );
  }
}

export default JobApplication;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/JobApplications/components/JobApplication/index.js